import Echo from 'laravel-echo';
import { useCallback } from 'react';
import { IPrivateChannelArgs, useUserPrivateChannel } from './useUserPrivateChannel.ts';
import { accountNotificationsActions } from '../../components/account/notification/accountNotificationsSlice.ts';
import { INotificationDto, mapINotificationDtoToModel } from '../../response/account/getMeResponse.ts';

interface IProps {
    echo: Echo<'pusher'> | null;
}

export const useAccountNotificationsListener = ({ echo }: IProps) => {
    const registerNotifications = useCallback(({ privateChannel, dispatch }: IPrivateChannelArgs) => {
        privateChannel?.listen('.notification.marked_as_read', (data: { id: string, isRead: boolean }) => {
            dispatch(accountNotificationsActions.markAsRead(data.id));
        });
        privateChannel?.listen('.notification.added', (data: { notification: INotificationDto }) => {
            dispatch(accountNotificationsActions.add(mapINotificationDtoToModel(data.notification)));
        });
        privateChannel?.listen('.notification.deleted', (data: { id: string }) => {
            dispatch(accountNotificationsActions.delete(data.id));
        });
    }, []);

    useUserPrivateChannel({ echo, registerListeners: registerNotifications });
};